import * as React from 'react';

interface ILadeForschrittProps {
  caption?: string;
}

/** Zeigt einen animierten Ladekreis mit anpassbarer Meldung an, z.B. wenn im Hintergrund Daten nachgeladen werden */
export default class LadeFortschritt extends React.Component<ILadeForschrittProps> {
  render() {
    return (
      <div className="loader-container">
        <div className="loader-sm"/>
        <div className="loader-text">{this.props.caption ? this.props.caption : 'Daten werden geladen...'}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/LadeFortschritt.tsx